import Service from '../../services'

const state = {
    roomTypes: [],
}


const getters = {

}


const actions = {
    onGetAllRoomTypes({ commit }) {
        return Service.base.getAllRoomTypes().then(async (data) => {
            const roomTypes = await Promise.all(data.map(async (roomType) => {
                const gallery = await Service.base.getAllRoomTypegalleryByRoomType(roomType.id)
                const roomAvailableAndMinimum = await Service.room.getRoomAvailableAndMinimumByRoomTypeId(roomType.id)

                return {
                    ...roomType,
                    gallery,
                    availableCount: roomAvailableAndMinimum.count,
                    minimum: roomAvailableAndMinimum.minimum
                }
            }))

            commit('setRoomTypes', roomTypes)
        })
    },
}


const mutations = {

    setRoomTypes(state, data) {
        state.roomTypes = data
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}